module.exports = __webpack_public_path__ + "static/media/DSC09534.5ad5c7f3.jpg";